import { useState } from "react";
import { RelatorioInadimplentesItem } from "core/features/relatorios/typings/index";
import { Box, Flex, Collapse, Text, Tag } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { BiChevronRight, BiChevronDown } from "react-icons/bi";
import TableItemInadimplente from "./../TableItemInadimplente/index";
import { formatMoney } from "infra/helpers/number";
import { tagSetorJuridicoString } from "features/conta/typings";

export interface ItemInadimplenteProps {
  item: RelatorioInadimplentesItem;
}

function ItemInadimplente({ item }: ItemInadimplenteProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((state) => !state);

  return (
    <Box>
      <Flex
        cursor="pointer"
        bg={colors.lightBlue}
        onClick={toggle}
        py={1}
        pr={6}
        pl={2}
        alignItems="center"
        borderBottom={`1px solid ${colors.gray}`}
      >
        <Flex alignItems="center" h="40px">
          {isOpen ? (
            <BiChevronDown size={25} color={colors.black700} />
          ) : (
            <BiChevronRight size={25} color={colors.black700} />
          )}
        </Flex>
        <Text ml={1} fontWeight="medium" fontSize="16px">
          {item.unidade}
          {item.responsavel ? " - " + item.responsavel : ""}
        </Text>
        {item.isJuridico ? (
          <Tag
            variant="outline"
            colorScheme="blue"
            borderRadius="8px"
            ml={4}
            px={4}
          >
            {tagSetorJuridicoString}
          </Tag>
        ) : null}

        {item.isAjuizada ? (
          <Tag
            variant="outline"
            colorScheme="purple"
            borderRadius="8px"
            ml={4}
            px={4}
          >
            Ajuizada
          </Tag>
        ) : null}

        {!isOpen ? (
          <Text ml={"auto"} fontWeight="bold">
            {formatMoney(item.total)}
          </Text>
        ) : null}
      </Flex>

      <Collapse in={isOpen}>
        <Box>
          <TableItemInadimplente item={item} />
        </Box>
      </Collapse>
    </Box>
  );
}

export default ItemInadimplente;
